<template>
  <div class="memberManage">
    <!-- 标题 -->
    <Title-Box :top-title="topTitle"></Title-Box>

    <!-- tab会员管理 -->
    <div class="tabContent manageArea boxs">
      <!-- tab会员管理-筛选框 -->
      <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
        <template slot="otherCom">

          <el-form-item>
            <el-input
                    v-model="searchForm.params.deviceModel"
                    placeholder="输入设备型号"
                    @keyup.enter.native="handleSearch"
                    maxlength="50"
                    size="medium"
                    clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
                    v-model="searchForm.params.deviceTitle"
                    placeholder="输入设备名称"
                    @keyup.enter.native="handleSearch"
                    maxlength="50"
                    size="medium"
                    clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
                    v-model="searchForm.params.deviceSn"
                    placeholder="输入设备序列号"
                    @keyup.enter.native="handleSearch"
                    maxlength="50" size="medium" clearable
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-select v-model="searchForm.params.status"
                       placeholder="选择状态"
                       clearable
                       filterable

            >
              <!-- <el-option label="无效" value="0"></el-option>
              <el-option label="有效" value="1"></el-option> -->
              <el-option
                      v-for="item in statusOptions"
                      :key="item.id"
                      :label="item.value"
                      :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

        </template>
      </sr-filter>


      <!--      <button class="butStyle pinkBtn exportBtn" @click="tableExport">-->
      <!--        <i class="exportIcon"></i>-->
      <!--        <span>导出</span>-->
      <!--      </button>-->

      <!--      <button class="butStyle greenBtn importBtn" @click="showImportDialog">-->
      <!--        <i class="importIcon"></i>-->
      <!--        <span>导入</span>-->
      <!--      </button>-->

      <!-- tab会员管理-表格 -->
      <div class="botTable tableTheadGray boxs">
        <div class="tableTop">
          <span class="leTableTit">设备管理列表</span>
          <div class="rightBox">
                <span class="top_ri flex_h_hR_vC">
                    <button class="butStyle pinkBtn exportBtn" @click="tableExport">
                        <i class="exportIcon"></i>
                        <span>导出</span>
                    </button>

                    <button class="butStyle greenBtn importBtn" @click="showImportDialog">
                        <i class="importIcon"></i>
                        <span>导入</span>
                    </button>
                </span>
          </div>
        </div>
        <el-table :data="tableData"
                  ref="multipleTable"
                  style="width: 100%;"
                  border
                  fit
                  highlight-current-row
                  tooltip-effect="dark"
                  @selection-change="selsChange"
                  @row-click="handleTableChange"
        >
          <!-- 这是列表前面的多选框 -->
          <!-- <el-table-column type="selection" align="center" width="35"></el-table-column> -->

          <el-table-column label="设备型号" prop="deviceModel" min-width="200" header-align="center" align="center"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column label="设备名称" prop="deviceTitle" min-width="200" header-align="center" align="center"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column label="设备序列号" prop="deviceSn" min-width="200" header-align="center" align="center"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column label="状态" prop="icon" min-width="100" header-align="center" align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span :class="{lightGText:scope.row.status.value=='2', orangeTextCurr:scope.row.status.value=='1'}">
              {{scope.row.status.text}}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="激活时间" prop="activateTime" min-width="200" header-align="center" align="center"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column label="激活会员" prop="activateMemberName" min-width="200" header-align="center" align="center"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column label="所属代理商" prop="agentMemberName" min-width="200" header-align="center" align="center"
                           show-overflow-tooltip>
          </el-table-column>

          <!-- <el-table-column label="操作" fixed="right" width="150" header-align="center" align="center" show-overflow-tooltip> -->
          <el-table-column label="操作" fixed="right" width="100" header-align="center" align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">

              <el-button
                      @click="showDeleteDialog(scope)"
                      class="orangeTextCurr"
                      icon="fa fa-trash" type="text"
                      title="删除"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pageBox boxs">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="searchForm.current"
                         :page-sizes="[10, 20, 30]"
                         :page-size="searchForm.rows"
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
            title="提示"
            :visible.sync="deleteMenuDialogVisible"
            width="30%">
      <span>确定删除吗？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="deleteMenuDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="deleteMpos">确 定</el-button>
  </span>
    </el-dialog>

    <el-dialog width="400px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog"
               :before-close="beforeClose" :close-on-click-modal=false :show-close="true">
      <el-form ref="form" :rules="rules" :model="postForm" label-width="92px" style="position:relative;">
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传文件：" prop="fieldId">
              <el-upload
                      action=""
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                      :on-success="handleUploadSuccess"
                      :on-error="handleUploadError"
                      :http-request="onUpload"
              >
                <template>
                  <el-button size="small" class="uploadBtn">
                    <span>请上传文件</span>
                    <i class="el-icon-upload el-icon--right"></i>
                  </el-button>
                  <span slot="tip" class="uploadTip">只能上传excel式文件</span>
                </template>
              </el-upload>
              <a @click="downloadTemplate" class="uploadTemplate">点击下载模板</a>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer flex-col">
                <div class="flex-row jus-c">
                    <button @click="beforeClose" class="butStyle cancelBtn">退 出</button>
                </div>
            </span>
    </el-dialog>

  </div>
</template>


<script>
  import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
  import SrFilter from '@/components/Common/Filter/Filter';
  import {objectToQueryString} from '@/utils/commonUtils.js';

  import {
    getMPosListAPI,
    deleteMPosAPI,
    importMposDataAPI
  } from '@/api/Resource/deviceManage.js'

  // 弹窗的数据
  const defaultPostForm = {
    name: null, //菜单名称
    path: null, // 菜单路由
    pid: null,
    icon: null
  }

  // 搜索表格的条件-筛选栏
  const defaultSearchForm = {
    params: {
      activateMemberName: '',
      deviceTitle: '',
      deviceSn: '',
      deviceModel: '',
      status: 0,
    },
    current: 1,
    size: 10
  }

  // 搜索表格的条件-筛选栏
  const defaultSelectMenu = {
    name: '无',
    id: '0',
  }

  export default {
    name: "DeviceMPos",
    data() {
      // 会员账号格式校验(只能输入数字和英文字母)
      const validateCode = (rule, value, callback) => {
        if (!value) {
          // 会员账号不能为空
          return callback(new Error('请输入会员账号'))
        }
        // 会员账号不为空时校验格式
        const regex = /^[0-9A-Za-z]+$/
        if (regex.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入数字或英文字母'))
        }
      }
      return {
        selectedItem: null,
        selectedRow: Object.assign({}, defaultSelectMenu),
        grandparentId: '',
        tableParams: {},
        //标题
        topTitle: {
          title: '设备管理-MPOS设备',
          subTit: ''
        },

        // 表格搜索条件
        searchForm: Object.assign({}, defaultSearchForm),
        // 会员类型
        statusOptions: [
          {id: 0, value: '全部状态'},
          {id: 1, value: '未激活'},
          {id: 2, value: '已激活'},
        ],

        // 表格数据
        tableData: [],
        // 表格已勾选数据
        checkedGouArrData: [],
        // 表格数据总数
        total: 0,
        // 表格勾选
        sels: [],
        // 批量选择下拉框
        batchValue: '',
        // 弹窗数据
        postForm: Object.assign({}, defaultPostForm),
        deleteMenuDialogVisible: false,
        // 添加/编辑窗口是否显示
        dialogFormVisible: false,
        // 弹窗标题
        dialogMap: {
          add: '添加会员',
          edit: '编辑会员'
        },
        dialogTitle: '',
        // 所属区域树窗口是否显示
        showMenuTree: false,
        // 区域树数据
        menuTreeData: [],
        // 区域树数据格式
        areaTreeProps: {
          children: 'children',
          label: 'name',
          labelId: 'id',
        },
        // 上级会员
        // 弹窗校验规则
        rules: {
          name: [{required: true, message: '请输入会员名称', trigger: 'blur'}],
        },
      }
    },
    components: {
      TitleBox,
      SrFilter
    },
    created() {
      // this.loadMenus()
      this.loadMposData()
    },
    methods: {

      // 导出
      tableExport() {
        const url = `${this.$baseNewUrl}esaleb-service-resource/mpos/export?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm.params)}`;
        window.open(url, '_blank');
      },

      // 弹出导入弹窗
      showImportDialog() {
        this.dialogTitle = 'import'
        this.dialogFormVisible = true
      },

      // 下载话费导入模板
      async downloadTemplate() {
        try {
          const url = `${this.$baseNewUrl}esaleb-service-resource/mpos/template?accessToken=${this.$accessToken()}`;
          window.open(url, '_blank');
        } catch (e) {
          console.log(e)
        }
      },

      // 话费导入(上传文件)
      onUpload(uploadObj) {
        let file = uploadObj.file
        let param = new FormData()
        param.append('file', file)

        importMposDataAPI(param).then(resp => {
          this.$message.success('导入成功')
          this.closeDialog()
          this.loadMposData()
        }).catch(err => {
          console.log(err)
        })
      },
      // 文件上传成功时的钩子
      handleUploadSuccess(res, file) {
      },
      // 文件上传失败时的钩子
      handleUploadError(res, file) {
        this.$message.error('文件上传失败！')
        this.$alert('文件上传失败！', '上传失败提示', {
          confirmButtonText: '确定',
          type: 'error',
          showClose: false,
          dangerouslyUseHTMLString: true
        })
      },
      beforeUpload(file) {
        // console.log(file)
        const isXls = file.type === 'application/vnd.ms-excel';
        const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isXls && !isXlsx) {
          this.$message.error('只能上传xls/xlsx文件!');
        }
        if (!isLt2M) {
          this.$message.error('文件大小不能超过 2MB!');
        }
        const check = isLt2M && (isXls || isXlsx);
        return check;
      },

      async loadMposData() {
        try {
          const result = await getMPosListAPI(this.searchForm);
          this.tableData = result.data.records
          this.total = result.data.total
          console.log(this.tableData)
        } catch (e) {

        }
      },

      // 列表每页条数变了
      handleSizeChange(val) {
        this.searchForm.size = val
        this.loadMposData()
      },
      // 列表当前页码变了
      handleCurrentChange(val) {
        this.searchForm.current = val
        this.loadMposData()
      },

      // 列表过滤查询
      handleSearch() {
        this.loadMposData()
      },
      // 搜索重置（清空）
      handleReset() {
        // 获取表格数据
        this.searchForm = {
          params: {
            activateMemberName: '',
            deviceTitle: '',
            deviceSn: '',
            deviceModel: '',
            status: 0,
          },
          current: 1,
          size: 10
        }
        this.loadMposData()
      },

      // 列表勾选
      selsChange(val) {
        this.sels = val
      },
      // 点击表格某一行
      handleTableChange(row, event, column) {
      },
      async deleteMpos() {
        try {
          await deleteMPosAPI(this.selectedRow.id)
          if (this.tableData.length == 1 && this.selectedRow.index == 0 && this.searchForm.current > 1) {
            this.searchForm.current = 1
          }
          this.$message.success('删除成功')
          this.deleteMenuDialogVisible = false
          this.loadMposData()
        } catch (e) {
          console.log(e)
        }
      },
      showDeleteDialog(data) {
        console.log(data)
        this.deleteMenuDialogVisible = true
        // 获取区域树数据
        this.postForm = JSON.parse(JSON.stringify(data.row))
        this.selectedRow = {
          index: data.$index,
          id: data.row.id
        }
      },

      // 弹窗关闭前
      beforeClose() {
        this.resetData()
      },
      // 关闭弹窗
      closeDialog() {
        this.resetData()
      },
      // 重置表单
      resetData() {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
        this.postForm = Object.assign({}, defaultPostForm)
        this.selectedRow = Object.assign({}, defaultSelectMenu)
      },

      // 验证表单-点击弹窗的“确定”按钮
      validateForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitForm()
          } else {
            this.dialogFormVisible = true
          }
        })
      },
      // 提交表单
      async submitForm() {
        if (this.dialogTitle === 'add') {
          this.addMenu();
        } else if (this.dialogTitle === 'edit') {
          this.editMenu();
        }
      },

      async addMenu() {
        this.postForm.pid = this.selectedRow.id
        try {
          const result = await addMenuAPI(this.postForm)
          this.$message.success('添加菜单成功')
          this.closeDialog()
          this.loadMposData()
        } catch (e) {
          console.log(e)
        }
      },

      async editMenu() {
        this.postForm.pid = this.selectedRow.id
        try {
          const result = await updateMenuAPI(this.postForm)
          this.$message.success('修改菜单成功')
          this.closeDialog()
          this.loadMposData()
        } catch (e) {
          console.log(e)
        }
      }
    }

  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  /* 文字顔色 */
  .greenText {
    color: #2DBAA5;
  }

  .lightGText {
    color: #76C819;
  }

  .orangeText {
    color: #FA6241;
  }

  .grayText {
    color: #7F7F7F;
  }

  // 批量操作
  .batchSel {
    width: 130px;
    margin-right: 5px;
  }

  .orangeBtn {
    color: #FFFFFF !important;
    background-color: #FA6241;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  // 按钮
  .el-button {
  }

  .greenBtn {
    color: #FFFFFF !important;
    background-color: #2DBAA5;

    &:hover {
      background-color: rgb(115, 196, 183);
    }
  }


  .memberManage {
    min-width: 1080px;
  }

  // tab切换-会员管理、会员架构图
  .memberManage .tabBox {
    padding-left: 4px;
    background: #fff;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }

  .tabBox li {
    float: left;
    width: 80px;
    color: #7F7F7F;
    font-size: 13px;
    font-weight: bold;
    cursor: pointer;
    position: relative;
  }

  .tabBox li.on {
    color: #F99A1A;
  }

  .tabBox li:after {
    content: '';
    position: absolute;
    width: 80px;
    height: 4px;
    background: transparent;
    bottom: -4px;
    left: 0;
  }

  .tabBox li.on:after {
    background: #F99A1A;
  }


  // tab内容区
  .memberManage .tabContent {

  }


  // tab内容区-会员管理
  .memberManage .tabContent.manageArea {

  }

  // 会员管理-表格
  .memberManage .tabContent.manageArea .botTable {
    width: 100%;
    margin-top: 14px;
  }

  .botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
  }

  .botTable .tableTop .leTableTit {
    font-size: 15px;
    font-weight: bold;
    color: #2B2727;
  }

  .botTable .tableTop .rightBox {
    width: auto;
    min-width: 200px; //考虑是否删去
    text-align: right;
    display: inline-block;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
  }


  // tab内容区-会员架构图
  .memberManage .tabContent.imgArea {

  }


  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
  }

  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  // 弹窗跳转-新增会员并配置工号
  .showMore {
    margin-top: 20px;
    width: 100%;
    height: 17px;
    line-height: 17px;
    color: #2DBAA5;
    font-size: 13px;
    position: relative;
    cursor: pointer;
  }

  .showMoreIcon {
    display: inline-block;
    width: 8px;
    height: 9px;
    margin-left: 3px;
    background: url('../../../assets/images/system/memberManage/ri_arrow_double.png') no-repeat;
    background-size: 100% 100%;
  }

  // 弹窗-区域
  .areaFormItem {
    position: relative;
  }

  .areaFormItem span {
    color: #FA6241;
  }

  // 弹窗-区域树盒子
  .areaFormItem .areaBox {
    width: 200px;
    height: 250px;
    // height: 150px;
    // max-height: 250px;
    // margin-left: 20px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    overflow-y: auto;
    overflow-x: auto;

    position: absolute;
    top: 33px;
    left: 0px;
    z-index: 2999;
  }


  .botTable .tableTop .top_ri .exportBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;
    margin-left: 10px;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  .botTable .tableTop .top_ri .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
  }

  .botTable .tableTop .top_ri .importBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;
    margin-left: 10px;
    background-color: #2DBAA5;

    &:hover {
      background-color: rgb(126, 187, 178);
    }
  }

  .botTable .tableTop .top_ri .importBtn .importIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/resource/NumCardManage/importIcon.png') no-repeat;
    background-size: 14px 14px;
  }


  .uploadBtn {
    font-size: 12px;
    color: #ffffff;
    border: none;
    background: #2DBAA5;

    &:hover {
      background-color: rgb(117, 189, 178);
    }
  }

  .uploadTip {
    //   display: inline;
    font-size: 12px;
    color: #AAAAAA;
    margin-left: 12px;
  }

  .uploadTemplate {
    display: inline;
    cursor: pointer;
    font-size: 12px;
    color: #2DBAA5;
    text-decoration: none;
  }

  .uploadTemplate :active {
    color: rgb(134, 189, 180);
  }

  .orangeTextCurr {
    color: #FA6241;
  }

</style>
